export const DEFAULT_TIP_PERCENTAGES = [18, 20, 22];
export const MAX_TIP_PERCENTAGE = 100;

const isValidPercentage = (value) =>
  Number.isFinite(value) && value > 0 && value <= MAX_TIP_PERCENTAGE;

export const resolveTipPercentages = (displaySettings) => {
  const saved = displaySettings?.tip_percentages;
  if (!Array.isArray(saved) || saved.length !== DEFAULT_TIP_PERCENTAGES.length) {
    return DEFAULT_TIP_PERCENTAGES;
  }

  const percentages = saved.map(Number);
  return percentages.every(isValidPercentage) ? percentages : DEFAULT_TIP_PERCENTAGES;
};
